import React from "react";

const NavStyle = {
  display: 'flex',
  height: '80px',
  padding: '0 2em',
  position: 'fixed',
  width: '100%',
  top: '0',
  left: '0',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: '#fff',
  zIndex: ' 10',
  boxShadow: 'rgba(0, 0, 0, 0.1) 0px 10px 50px',
}

const ImageStyle = {
  maxWidth: '200px',
  maxHeight: '60px',
}

const H3 = {
  textAlign: 'center',
  fontWeight: '600',
}

const NavigationBar = ({ images }) => {
  return (
    <nav style={NavStyle}>
      <img style={ImageStyle} src={images.left} alt="3destate"/>
      <img style={ImageStyle} src={images.center} alt="sbdim"/>
      <img style={ImageStyle} src={images.right} alt="sbdim"/>
    </nav>
  )
}

export default NavigationBar;
